import { toDate as o } from "./toDate.js";
function g(a, n) {
  const t = o(a), e = o(n);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
export {
  g as default,
  g as isSameMonth
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/isSameMonth.js
// module id = 888
// module chunks = 67